const userAgent = navigator.userAgent.toLowerCase();
export const isSafari = userAgent.includes('safari') && !userAgent.includes('chrome');
